import { createReducer, on } from '@ngrx/store';
import * as AirlinelistActions from './Airlinelist.action';

export interface AirlineState {
  airlines: any[];
  loading: boolean;
  error: string | null;
}

export const initialState: AirlineState = {
  airlines: [],
  loading: false,
  error: null,
};

export const airlinelistReducer = createReducer(
  initialState,
  on(AirlinelistActions.loadAirlines, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(AirlinelistActions.loadAirlinesSuccess, (state, { airlines }) => ({
    ...state,
    airlines,
    loading: false,
  })),
  on(AirlinelistActions.loadAirlinesFailure, (state, { error }) => ({
    ...state,
    error,
    loading: false,
  }))
);
